export const skillset = [
    {
        name: "HTML",
        img: "html.png"
    },

    {
        name: "CSS",
        img: "css-3.png"
    },

    {
        name: "JAVASRIPT",
        img: "javascript.png"
    },

    {
        name: "TYPESCRIPT",
        img: "typescript.png"
    },

    {
        name: "BOOTSTRAP",
        img: "bootstrap.png"
    },

    {
        name: "MySql",
        img: "mysql.png"
    },

    {
        name: "PostgreSQl",
        img: "postgre.png"
    },

    {
        name: "REACT",
        img: "react.png"
    },

    {
        name: "NodeJS",
        img: "nodejs.png"
    },


    {
        name: "NextJS",
        img: "nextjs.jpeg"
    },

    {
        name: "JAVA",
        img: "java.png"
    },

    {
        name: "PYTHON",
        img: "python.png"
    },

    {
        name: "C++",
        img: "c-logo.png"
    },

]

export const tools = [
    {
        name:"Vscode",
        img: "vscode.png"
    },

    {
        name:"Postman",
        img: "postman.png"
    },

    {
        name:"Ubuntu",
        img: "ubuntu.png"
    },

    {
        name:"GitHub",
        img: "github.png"
    },

    {
        name:"vercel",
        img: "vercel.png"
    }
]